import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { API_INTERACT_URL, axiosInt } from '../../index';
import type { IRoute } from '../../types/routes';

export const FETCH_ROUTES_KEY = 'fetchRoutes';
export const fetchRoutesApi = async (): Promise<IRoute[]> => {
  const response = await axiosInt.get(`${API_INTERACT_URL}/routes`);
  return response.data;
};

const useFetchRoutes = (options?: Partial<UseQueryOptions<IRoute[]>>) => {
  const {
    data: routes,
    isLoading: isLoadingRoutes,
    error: errorFetchingRoutes,
  } = useQuery<IRoute[]>({
    queryKey: [FETCH_ROUTES_KEY],
    queryFn: () => fetchRoutesApi(),
    ...options,
  });

  return { routes, isLoadingRoutes, errorFetchingRoutes };
};

export default useFetchRoutes;
